
import { defineComponent } from 'vue'
import { eventBus, BusEvent } from '@/services/EventBus'

interface Toast {
  background: boolean
  message: string,
  icon: string
}

class DefaultToast implements Toast {
  background = true
  message = ''
  icon = 'info-circle'
  title = 'Information'
}

export default defineComponent({
  created () {
    eventBus.listen('toast', this.showToast)
  },
  data () {
    return {
      toast: new DefaultToast()
    }
  },
  methods: {
    showToast (e: BusEvent) {
      const modal = this.$refs.modal as HTMLElement
      const contentDom = modal.querySelector('.box') as HTMLElement
      if (contentDom) {
        Object.assign(this.toast, e.payload)
        if (!modal.classList.contains('is-active')) {
          modal.classList.add('is-active')
          setTimeout(() => {
            this.toast = new DefaultToast()
            modal.classList.remove('is-active')
          }, 2000)
        }
      }
    }
  }
})
